module.exports = {"511826001":"芦阳街道","511826101":"飞仙关镇","511826102":"双石镇","511826103":"太平镇","511826104":"大川镇","511826105":"思延镇","511826106":"龙门镇","511826201":"清仁乡","511826203":"宝盛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511826.json
// module id = 2386
// module chunks = 0